import React, { Component } from 'react'
import Plyr from 'react-plyr'
import { withRouter, Link } from 'react-router-dom'
import { isEmpty } from 'ramda'
import Images from '../Images/Images'
import Sipecka from './Sipecka'
import AuthorInfo from './AuthorInfo'
import AudioPlayer from '../Audio/AudioPlayer'
import LikeBtn from './LikeBtn'
import { postProp } from '../../propTypes'
import { typeFromProps, idFromUrl, audioSrcFromProps } from './helpers'
import './Post.css'

class Post extends Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps.slug !== this.props.slug || nextProps.colWidth !== this.props.colWidth) {
      return true
    }
    return false
  }

  render() {
    const id = this.props.youtube && idFromUrl(this.props.youtube)
    const type = typeFromProps(this.props)
    const is89 = this.props.location.pathname.startsWith('/89')
    const start = is89 ? '/89' : ''
    const to = `${start}/prispevok/${this.props.slug}`
    const audioSrc = audioSrcFromProps(this.props, is89)

    return (
      <div
        className="Post"
        style={{
          width: this.props.colWidth,
        }}
      >
        {id && <Plyr type="youtube" className={`plyr${id}`} videoId={id} />}
        {!id && !isEmpty(this.props.images) && (
          <Images to={to} width={this.props.colWidth} images={this.props.images} />
        )}

        <div className="content">
          {audioSrc && <AudioPlayer
            resolveUrl={audioSrc}
            streamUrl={audioSrc}
            preloadType="metadata"
          />}
          <AuthorInfo
            linkDetail={to}
            type={type}
            date={this.props.date}
            name={this.props.name}
          />

          <Link to={to} className="text" dangerouslySetInnerHTML={{ __html: this.props.shortText }} />
          <Sipecka to={to} />
          <LikeBtn to={to} />
        </div>
      </div>
    )
  }
}

Post.propTypes = postProp.isRequired

Post.defaultProps = {
  images: [],
  files: [],
}

export default withRouter(Post)



// WEBPACK FOOTER //
// ./src/components/Post/Post.js